export default __webpack_public_path__ + "static/Kenneth Li_015_WEB_BW-7f426e002468bb0d4f1cb0330f85386e.jpg";